const SurinameSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112473)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M38.7559 13.043H1.24391C0.440078 15.2097 0 17.553 0 19.9995C0 22.4459 0.440078 24.7894 1.24391 26.9559H38.756C39.56 24.7894 40 22.4459 40 19.9995C40 17.553 39.56 15.2097 38.7559 13.043Z"
        fill="#A2001D"
      />
      <path
        d="M20.0577 40.0003C26.9079 40.0003 32.9529 36.5556 36.5574 31.3047H3.55811C7.16264 36.5556 13.2075 40.0003 20.0577 40.0003Z"
        fill="#6DA544"
      />
      <path
        d="M20.0577 0C26.9079 0 32.9529 3.44469 36.5574 8.69563H3.55811C7.16264 3.44469 13.2075 0 20.0577 0Z"
        fill="#6DA544"
      />
      <path
        d="M20.0001 13.043L21.7267 18.357H27.3146L22.794 21.6417L24.5208 26.9559L20.0001 23.6716L15.4794 26.9559L17.2063 21.6417L12.6855 18.357H18.2734L20.0001 13.043Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112473">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SurinameSvg;
